<template>
  <v-container style="height: 100vh" class="ma-0 pa-0" fluid>
    <v-row style="height: 100%;">
      <v-col cols="6" class="vertical">
        <v-container ma-0 pa-0 fluid style="width: 80%">
          <v-row justify="center">
            <h1 style="font-size: 50px">BOLKI</h1>
          </v-row>
          <v-row>
            <p>Melden Sie sich jetzt an.</p>
          </v-row>
          <v-row justify="center" class="pb-4">
            <LoginModule style="width: 100%"/>
          </v-row>
          <v-row justify="end">
            <PasswordReset/>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="6" class="background vertical ma-0 pa-0">
        <div id="pagetitle"><h1 style="font-size: 50px; text-align: center">Bildbasierte Objekterkennung in der Landwirtschaft mittels KI</h1></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LoginModule from '@/components/LoginModule.vue'
import PasswordReset from '../components/PasswordReset.vue';

export default {
  components: {
    LoginModule,
    PasswordReset
  },
};
</script>

<style>
.background {
  background-image  : url("../assets/seegras.jpg");
  background-size   : cover;
  background-repeat : no-repeat;
}

.vertical {
  display         : flex;
  align-items     : center;
  justify-content : center;
}

/* Title: Bildbasierte Objekterkennung */
div#pagetitle {
  color   : #ffffff !important;
  /*https://www.w3schools.com/css/css_align.asp ??? */
  padding : 20% 0;
}
</style>